// extracted by mini-css-extract-plugin
export var blog = "blog-card-module--blog--IqEj1";
export var imgContainer = "blog-card-module--img-container--9Dp4y";
export var img = "blog-card-module--img--yjx6q";
export var link = "blog-card-module--link--FSGdy";
export var footer = "blog-card-module--footer--IA0jB";
export var date = "blog-card-module--date--jtUoh";